import React, { useDeferredValue, useMemo, useState } from 'react';
import { Button, Collapse } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import CustomPagination from '../../components/CustomPagination';
import MenuComponent from '../../components/MenuComponent';
import PageHeader from "../../components/PageHeader";
import useLiveDataTable from '../../hooks/useLiveDataTable';
import { useEditModeMutation, useGetDriverRecruitmentQuery, useRemoveDriverMutation, useResendInviteMutation, useUpdateStatusMutation } from '../../redux/services/DriverService';
import { deleteConfirmation, hideLoader, loadingConfirmation, showLoader, sweetAlert } from "../../utils";
import DriverViewSide from './DriverSideView';
import Filter from './Filter';
import debounce from '../../utils/debounce';


const DriversPage = () => {
    const navigate = useNavigate()
    const {
        currentPage,
        perPage,
        q,
        searchQuery,
        setSearchQuery,
        handlePageChange,
        handlePerPageChange,
        handleSearchChange,
        onSearchKeyHandler,
        handleSearchBy,
        searchBy,
    } = useLiveDataTable();

    const [isShow, setIsShow] = useState(false)
    const [isEdit, setIsEdit] = useState(null)
    const [isView, setIsView] = useState(false)
    const [isFilter, setIsFilter] = useState(false)
    const [query, setQuery] = useState(null)
    const params = useDeferredValue(query)



 const [searchText, setSearchText] = useState('');

   const debouncedSearch = useMemo(
    () =>
        debounce((value) => {
            handleSearchChange(value); 
        }, 500),
    []
);


    const handleSearchInput = (e) => {
        const value = e.target.value;
        setSearchText(value);
        debouncedSearch(value);
    };



    const [removeRequest] = useRemoveDriverMutation()
    const [inviteRequest] = useResendInviteMutation()
    const [editModeRequest] = useEditModeMutation()
    const [updateStatus, { isLoading: isLoadinStatus }] = useUpdateStatusMutation()



    const { data: data2, isLoading, isFetching, refetch } = useGetDriverRecruitmentQuery(`&page=${currentPage}&perPage=${perPage}&search_by=${searchBy}&search=${q}${params?.id ? '&document_status=' + params?.id : ''}`)
    const drivers = data2?.response?.data?.data
    const total = data2?.response?.data?.total;



    const handleAdd = () => {
        setIsEdit(null)
        setIsShow(true)
        // reset()
    }

    const handleEdit = (items) => {
        setIsEdit(items)
        setIsShow(true)
    }

    const handleEditMode = async (item) => {
        showLoader('Updating')
        await editModeRequest(item?.id)
            .unwrap()
            .then((res) => {
                if (res?.status) {
                    hideLoader()
                    sweetAlert(res?.message, 'success')
                    refetch()
                }
            })
            .catch((err) => {
                hideLoader()
                sweetAlert(err?.data?.message, 'error')

            })

    }

    const handleResendInvitation = async (item) => {
        showLoader('Inviting')
        await inviteRequest(item?.id)
            .unwrap()
            .then((res) => {
                if (res?.status) {
                    hideLoader()
                    sweetAlert(res?.message, 'success')
                    refetch()
                }
            })
            .catch((err) => {
                hideLoader()
                sweetAlert(err?.data?.message, 'error')
            })
    }

    const statusColor = (status) => {
        switch (status) {
            case 0:
                return '#f7b725'
            case 1:
                return '#44b86c'
            case 2:
                return '#e82646'
            case 3:
                return '#17b1df'
            case 4:
                return '#17b1df'
            default:
                return 'black'
        }
    }



    const data = [
        {
            driverName: 'Muhammad Usama',
            dlNumber: '123456789',
            email: 'usamaasif4190@gmail.com',
            phone: '+923456413071',
            applicationStatus: 'Pending',
            applicationEditable: true,
            expiryDate: '2024-10-15', // Expiry date 16 days from now
        },
        {
            driverName: 'Alice Johnson',
            dlNumber: '987654321',
            email: 'alice.johnson@example.com',
            phone: '+1234567890',
            applicationStatus: 'Submitted',
            applicationEditable: false,
            expiryDate: '2024-09-30', // Expiry date today
        },
        {
            driverName: 'Bob Smith',
            dlNumber: '456789123',
            email: 'bob.smith@example.com',
            phone: '+0987654321',
            applicationStatus: 'Approved',
            applicationEditable: true,
            expiryDate: '2024-11-05', // Expiry date 37 days from now
        },
        {
            driverName: 'Charlie Brown',
            dlNumber: '321654987',
            email: 'charlie.brown@example.com',
            phone: '+1122334455',
            applicationStatus: 'Pending',
            applicationEditable: false,
            expiryDate: '2024-10-02', // Expiry date 3 days from now
        },
        {
            driverName: 'Diana Prince',
            dlNumber: '654987321',
            email: 'diana.prince@example.com',
            phone: '+5566778899',
            applicationStatus: 'Submitted',
            applicationEditable: true,
            expiryDate: '2024-10-10', // Expiry date 11 days from now
        },
        {
            driverName: 'Edward Stark',
            dlNumber: '789123456',
            email: 'edward.stark@example.com',
            phone: '+6677889900',
            applicationStatus: 'Approved',
            applicationEditable: false,
            expiryDate: '2024-09-25', // Expiry date 4 days ago
        },
        {
            driverName: 'Fiona Green',
            dlNumber: '159753486',
            email: 'fiona.green@example.com',
            phone: '+1234567890',
            applicationStatus: 'Pending',
            applicationEditable: true,
            expiryDate: '2024-10-25', // Expiry date 26 days from now
        },
        {
            driverName: 'George White',
            dlNumber: '753159852',
            email: 'george.white@example.com',
            phone: '+0987654321',
            applicationStatus: 'Submitted',
            applicationEditable: false,
            expiryDate: '2024-09-28', // Expiry date 1 day from now
        },
        {
            driverName: 'Hannah Blue',
            dlNumber: '258741963',
            email: 'hannah.blue@example.com',
            phone: '+1122334455',
            applicationStatus: 'Approved',
            applicationEditable: true,
            expiryDate: '2024-11-20', // Expiry date 52 days from now
        },
        {
            driverName: 'Ian Black',
            dlNumber: '369852741',
            email: 'ian.black@example.com',
            phone: '+5566778899',
            applicationStatus: 'Pending',
            applicationEditable: false,
            expiryDate: '2024-10-01', // Expiry date tomorrow
        },
        {
            driverName: 'Jack Wilson',
            dlNumber: '852963741',
            email: 'jack.wilson@example.com',
            phone: '+2233445566',
            applicationStatus: 'Submitted',
            applicationEditable: true,
            expiryDate: '2024-09-15', // Expiry date 14 days ago
        },
        {
            driverName: 'Karen Taylor',
            dlNumber: '147258369',
            email: 'karen.taylor@example.com',
            phone: '+3344556677',
            applicationStatus: 'Approved',
            applicationEditable: false,
            expiryDate: '2024-10-30', // Expiry date 31 days from now
        },
        {
            driverName: 'Liam Harris',
            dlNumber: '963852741',
            email: 'liam.harris@example.com',
            phone: '+4455667788',
            applicationStatus: 'Pending',
            applicationEditable: true,
            expiryDate: '2024-09-20', // Expiry date 9 days ago
        },
        {
            driverName: 'Megan Clark',
            dlNumber: '741258963',
            email: 'megan.clark@example.com',
            phone: '+5566778899',
            applicationStatus: 'Submitted',
            applicationEditable: false,
            expiryDate: '2024-11-01', // Expiry date 33 days from now
        },
        {
            driverName: 'Nolan Lewis',
            dlNumber: '852741963',
            email: 'nolan.lewis@example.com',
            phone: '+6677889900',
            applicationStatus: 'Approved',
            applicationEditable: true,
            expiryDate: '2024-10-05', // Expiry date 6 days from now
        },
        {
            driverName: 'Olivia Martinez',
            dlNumber: '951753852',
            email: 'olivia.martinez@example.com',
            phone: '+7788990011',
            applicationStatus: 'Pending',
            applicationEditable: false,
            expiryDate: '2024-09-29', // Expiry date tomorrow
        },
        {
            driverName: 'Paul Robinson',
            dlNumber: '753852147',
            email: 'paul.robinson@example.com',
            phone: '+8899001122',
            applicationStatus: 'Submitted',
            applicationEditable: true,
            expiryDate: '2024-10-12', // Expiry date 13 days from now
        },
        {
            driverName: 'Quinn Adams',
            dlNumber: '456123789',
            email: 'quinn.adams@example.com',
            phone: '+9900112233',
            applicationStatus: 'Approved',
            applicationEditable: false,
            expiryDate: '2024-11-15', // Expiry date 47 days from now
        },
        {
            driverName: 'Rachel Evans',
            dlNumber: '321789654',
            email: 'rachel.evans@example.com',
            phone: '+1122334455',
            applicationStatus: 'Pending',
            applicationEditable: true,
            expiryDate: '2024-09-22', // Expiry date 1 day ago
        },
        {
            driverName: 'Steve Hall',
            dlNumber: '654321987',
            email: 'steve.hall@example.com',
            phone: '+2233445566',
            applicationStatus: 'Submitted',
            applicationEditable: false,
            expiryDate: '2024-10-15', // Expiry date 16 days from now
        },
        {
            driverName: 'Tina Allen',
            dlNumber: '789456123',
            email: 'tina.allen@example.com',
            phone: '+3344556677',
            applicationStatus: 'Approved',
            applicationEditable: true,
            expiryDate: '2024-10-22', // Expiry date 23 days from now
        },
        {
            driverName: 'Uma Patel',
            dlNumber: '987654321',
            email: 'uma.patel@example.com',
            phone: '+4455667788',
            applicationStatus: 'Pending',
            applicationEditable: false,
            expiryDate: '2024-09-30', // Expiry date today
        },
    ];

    const [open, setOpen] = useState(false);

    return (
        <>
            <PageHeader name="Driver Onboarding" />


            <div className="main-container container-fluid">

                {" "}
                {/* Start::row-1 */}
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card custom-card">
                            <div className="card-header w-100">
                                <div className="row w-100 m-0 ">
                                    <div className="col-auto p-0 d-flex">
                                        <Button
                                            className="btn btn-primary"
                                            onClick={() => navigate(`/driver/add`, { state: { isEdit: null } })}
                                        >
                                            Invite New Driver
                                        </Button>
                                    </div>
                                    <div className="col-auto p-0 d-flex ms-2">
                                        <Button
                                            className="btn btn-primary"
                                            onClick={() => refetch()}
                                        >
                                            Refresh
                                        </Button>
                                    </div>
                                    <div className="col-auto p-0 ms-1">
                                        <Button
                                            className="btn btn-primary  "
                                            onClick={() => setOpen(!open)} // Toggle collapse
                                            aria-controls="collapse-inputs"
                                            aria-expanded={open}
                                        >
                                            <i className="ri-filter-2-fill" />
                                        </Button>
                                    </div>

                                    <div className="col-auto ms-auto">
                                        <button className="btn bg-light text-capitalize">
                                             Search By:
                                            <span className='text-success ms-1'>
                                                {searchBy?.split('_')?.join(' ')?.replace('full name', 'driver name')}
                                            </span>
                                        </button>
                                    </div>
                                    <div className="col-lg-3 col-5 p-0">
                                        <div className="input-group m-0">
                                            <input
                                                className="form-control"
                                                type="text"
                                                placeholder="Search Here..."
                                                value={searchText}
                                                onChange={handleSearchInput}
                                            />
                                            <span className="input-group-text bg-transparent border text-primary">
                                                <i className="ri-search-line" />
                                            </span>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Collapse in={open}>
                                <div className="w-100">
                                    <Filter setQuery={setQuery} />
                                </div>
                            </Collapse>
                            <div className="card-body">

                                <CustomPagination
                                    isFetching={isFetching}
                                    data={drivers}
                                    total={total}
                                    onChangePage={handlePageChange} // Handle page change
                                    onChangeRowsPerPage={handlePerPageChange} // Handle per page change
                                    paginationDefaultPage={currentPage} // Set the current page

                                    columns={[
                                        {
                                            selector: row => row.full_name,
                                            sortable: true,
                                            name: (
                                                <span
                                                    onClick={() => handleSearchBy('full_name')}
                                                >
                                                    {searchBy == 'full_name' ? <b className='text-success'>Driver Name</b> : 'Driver Name'}
                                                </span>
                                            )
                                        },
                                        {
                                            selector: row => row.dln,
                                            sortable: true,
                                            name: (
                                                <span
                                                    onClick={() => handleSearchBy('dln')}
                                                >
                                                    {searchBy == 'dln' ? <b className='text-success'>DL Number</b> : 'DL Number'}
                                                </span>
                                            )
                                        },
                                        {
                                            selector: row => row.email,
                                            sortable: true,
                                            width: '240px',
                                            name: (
                                                <span
                                                    onClick={() => handleSearchBy('email')}
                                                >
                                                    {searchBy == 'email' ? <b className='text-success'>Email</b> : 'Email'}
                                                </span>
                                            )
                                        },
                                        {
                                            selector: row => row.phone,
                                            sortable: true,
                                            name: (
                                                <span
                                                    onClick={() => handleSearchBy('phone')}
                                                >
                                                    {searchBy == 'phone' ? <b className='text-success'>Phone</b> : 'Phone'}
                                                </span>
                                            )
                                        },
                                        {
                                            name: 'Application Status',
                                            cell: row => (
                                                <>
                                                    {/* { title: 'Pending', id: 0 }, { title: 'Submitted', id: 1 }, */}
                                                    <MenuComponent
                                                        data={[{ title: 'Pending', id: 0 }, { title: 'Submitted', id: 1 }, { title: 'Reject', id: 2 }, { title: 'Approved', id: 3 }, { title: 'Revision', id: 4 }]}
                                                        selectedData={row?.status?.title ? row?.status?.title : 'Select Status'}
                                                        selectdId={`${row?.document_status}`}
                                                        color={statusColor(parseInt(row?.document_status)) || 'black'}
                                                        update={updateStatus}
                                                        title={'Select Driver Recruitment Status'}
                                                        isLoading={isLoadinStatus}
                                                        id={row?.id}
                                                        updateKey={'status'}
                                                        disables={[0, 1]}
                                                    // refetch={refetch}
                                                    />
                                                </>
                                            ),
                                            sortable: true,
                                        },
                                        {
                                            name: 'Application Editable',
                                            cell: row => (
                                                <div className="form-switch">
                                                    {/* {row?.is_application_editable} */}
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        defaultChecked={row.is_application_editable == 0 ? false : true} readOnly
                                                        onChange={() => handleEditMode(row)}
                                                    />
                                                </div>
                                            ),
                                            sortable: false,
                                        },
                                        {
                                            name: 'Actions',
                                            cell: (row, i) => {
                                                return (
                                                    <div className="hstack gap-1 fs-1">
                                                        <button
                                                            aria-label="view"
                                                            onClick={() => loadingConfirmation(() => inviteRequest(row?.id), 'Inviting')}
                                                            className="btn btn-sm btn-primary-light btn-wave waves-effect waves-light"
                                                        >
                                                            Resend Invite
                                                        </button>
                                                        <Link
                                                            to={`/drivers/view/${row?.id}`}
                                                            state={{ alert: false }}
                                                            aria-label="view"
                                                            // onClick={() => setIsView(true)}
                                                            className="btn btn-icon btn-sm btn-primary-light btn-wave waves-effect waves-light"
                                                        >
                                                            <i className="ri-eye-fill" />
                                                        </Link>
                                                        <button
                                                            aria-label="edit"
                                                            onClick={() => navigate(`/driver/edit/${row?.id}`, { state: { isEdit: row } })}
                                                            className="btn btn-icon btn-sm btn-info-light btn-wave waves-effect waves-light"
                                                        >
                                                            <i className="ri-edit-line" />
                                                        </button>
                                                        <a
                                                            aria-label="delete"
                                                            onClick={() => deleteConfirmation(() => removeRequest(row?.id))}
                                                            className="btn btn-icon btn-sm btn-danger-light btn-wave waves-effect waves-light"
                                                        >
                                                            <i className="ri-delete-bin-7-line" />
                                                        </a>
                                                    </div>
                                                )
                                            },
                                            ignoreRowClick: true,
                                            allowOverflow: true,
                                            button: true,
                                            width: '220px'
                                        },
                                    ]}

                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* {isShow && (
                <DriversAddModal
                    show={isShow}
                    handleClose={() => {
                        setIsShow(false)
                        setIsEdit(null)
                    }}
                    isEdit={isEdit}
                />
            )} */}

            {/* <DriverCreateModal
                show={isShow}
                handleClose={() => setIsShow(false)}
            />
            <TeamEditModal
                show={isEdit}
                handleClose={() => setIsEdit(false)}
            /> */}

            <DriverViewSide
                show={isView}
                close={() => setIsView(false)}
            />


        </>
    );
};

export default DriversPage;